import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { Alert, message } from 'antd'
import * as d3 from 'd3'

import { importPartnerReferrals } from '../services'
import { getEmployees } from '../../Employees/services'
import { handleError } from '../../../helpers'

export default function ImportPartnerReferralsModal({ visible, onClose, reload }) {
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState(null)
	const [results, setResults] = useState({})
	const [partnerId, setPartnerId] = useState('')
	const [partners, setPartners] = useState(null)

	const uploadFile = useRef(null)

	useEffect(() => {
		!partners && getEmployees({ 'filter[partners]': 1, 'filter[active]': 1 })
			.then(res => setPartners(res.data.data))
			.catch(error => handleError(error))
	}, [ partners ])
	
	const handleFiles = () => {
		(async () => {
			const text = await uploadFile.current.files[0].text()
			if(uploadFile.current.files[0].type !== 'text/csv')
				return message.warning('Favor ingresar únicamente archivos .csv')
				
			setData(d3.csvParse(text))
		})()
	}

	const handleSubmit = () => {
		setLoading(true)
		
		importPartnerReferrals({ employee_id: partnerId, rows: JSON.stringify(data) })
			.then(res => {
				message.success(res.data.message)
				setResults(res.data.data)
				reload()
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Importar Referidos de Convenio Masivamente</ModalHeader>
			<ModalBody>
				<Form.Group>
					<Form.Label>Convenio <span className='text-danger'>*</span></Form.Label>
					<Form.Control
						as="select"
						value={partnerId}
						onChange={e => setPartnerId(e.target.value)}
					>
						<option value="">:: Seleccione un convenio ::</option>
						{ partners?.map(partner => (
							<option key={partner.id} value={partner.id}>{partner.name}</option>
						))}
					</Form.Control>
				</Form.Group>
				<Form.Group>
					<Form.Label>Archivo CSV <span className='text-danger'>*</span></Form.Label>
					<Form.Control
						type="file"
						ref={uploadFile}
						onChange={handleFiles}
						className='block mb-2'
						disabled={!partnerId}
					/>
				</Form.Group>
				<Alert type='warning' description="Alerta: Todos los referidos actuales se eliminarán y se importarán los nuevos." />
				<Button 
					color="primary" 
					onClick={handleSubmit} 
					disabled={!data || loading}
					className="mt-2"
				>
					Importar Referidos de Convenio{" "}
					{ loading && <Spinner size="sm" className='ml-3' /> }
				</Button>
				<div className='mt-2 py-3 bg-light'>
					<ol>
						{ results.length > 0 && (
							<React.Fragment>
								{ results.map((result, i) => (
									<li key={i}>
										<strong>Fila #0{result.row}: </strong>{result.comment}
									</li>
								))}
							</React.Fragment>
						)}
					</ol>
				</div>
			</ModalBody>
		</Modal>
	)
}